import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function PaymentThanksPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const canceled = params.get("canceled") === "1";
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus(canceled ? "canceled" : "unknown"); return; }
    let tries = 0;
    const t = setInterval(async () => {
      tries += 1;
      try {
        const r = await fetch(`${BASE}/api/pay/session/${sessionId}`);
        const d = await r.json();
        if (d.payment_status === "paid") { setStatus("paid"); clearInterval(t); return; }
      } catch { /* keep polling */ }
      if (tries >= 10) { setStatus(canceled ? "canceled" : "pending"); clearInterval(t); }
    }, 2000);
    return () => clearInterval(t);
  }, [sessionId, canceled]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-50 px-4" data-testid="pay-thanks-page">
      <div className="w-full max-w-md rounded-2xl border border-stone-200 bg-white p-8 text-center shadow-sm">
        <img src="/shc-logo.png" alt="Silver Home Care" className="mx-auto h-12 w-auto" />
        {status === "paid" ? (
          <>
            <CheckCircle size={40} weight="fill" className="mx-auto mt-5 text-[#27AE60]" />
            <h1 className="mt-3 font-heading text-2xl font-semibold text-stone-900" data-testid="pay-status">Payment received</h1>
            <p className="mt-2 text-sm text-stone-500">Thank you — your payment went through and the invoice is marked paid. A receipt comes from the card processor by email.</p>
          </>
        ) : status === "canceled" ? (
          <>
            <XCircle size={40} className="mx-auto mt-5 text-stone-400" />
            <h1 className="mt-3 font-heading text-2xl font-semibold text-stone-900" data-testid="pay-status">Payment not completed</h1>
            <p className="mt-2 text-sm text-stone-500">No charge was made. You can use the pay link in your invoice email anytime, or pay by Venmo, Zelle, or check.</p>
          </>
        ) : status === "checking" ? (
          <>
            <CircleNotch size={36} className="mx-auto mt-5 animate-spin text-primary" />
            <p className="mt-3 text-sm text-stone-500" data-testid="pay-status">Confirming your payment…</p>
          </>
        ) : (
          <>
            <h1 className="mt-5 font-heading text-2xl font-semibold text-stone-900" data-testid="pay-status">We're confirming your payment</h1>
            <p className="mt-2 text-sm text-stone-500">If you completed the card payment, it will post within a few minutes. Questions? Call the office at 800-719-6912.</p>
          </>
        )}
        <p className="mt-6 text-xs text-stone-400">Silver Home Care · 800-719-6912 · <Link to="/" className="underline">silverhomecare</Link></p>
      </div>
    </div>
  );
}
